import React from 'react';
import { arrayOf, shape, string, func } from 'prop-types';

import { OpportunityFilterSavedSearchesItem } from './OpportunityFilterSavedSearchesItem';

export const OpportunityFiltersSavedSearches = ({
  userFilters = [],
  handleFilterLoad,
  handleRenderFilter,
}) => (
  <>
    {userFilters.map(filter => (
      <OpportunityFilterSavedSearchesItem
        key={filter.id}
        userFilter={filter}
        handleFilterLoad={handleFilterLoad}
        handleRenderFilter={handleRenderFilter}
      />
    ))}
    {userFilters.length === 0 && <p>No filters saved</p>}
  </>
);

OpportunityFiltersSavedSearches.propTypes = {
  handleFilterLoad: func.isRequired,
  handleRenderFilter: func.isRequired,
  userFilters: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
    }).isRequired
  ).isRequired,
};
